import {Time} from "@angular/common";

export class LessonSchedule {
  public constructor(init?: Partial<LessonSchedule>) {
    Object.assign(this, init);
  }

  id: number;
  name: string;
  nameHebrew: string;
  teacherId: number;
  roomId: number;
  startTime: Time;
  endTime: Time;
  isOnline: boolean;
  maxStudents: number;
  minAge: number;
  maxAge: number;
  startDate: string;
  endDate: string;
  dayOfWeek: string;
  isRescheduled: boolean;
  cancelledDates: string[];
}
